import { useSyncExternalStore } from "react";

/** Requête média suivie (largeur d'une tablette, par exemple), mise à jour au redimensionnement ou à la
 *  rotation de l'écran. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => true,
  );
}
